import { render } from "./StepBackward.vue?vue&type=template&id=4d96b390"
import script from "./StepBackward.vue?vue&type=script&lang=js"
export * from "./StepBackward.vue?vue&type=script&lang=js"
script.render = render

export default script